export const types = {
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_FAILURE: "GET_NOTIFICATIONS_FAILURE",
  SHOW_NOTIFICATIONS_BAR: "SHOW_NOTIFICATIONS_BAR",
};

export const initialState = {
  notifications: null,
  notificationsFetching: false,
  notificationsError: false,
  showNotificationsBar: false,
};

export const actions = {
  getNotifications: (origin, productId, userRecom) => ({
    type: types.GET_NOTIFICATIONS,
    origin,
    productId,
    userRecom,
  }),
  getNotificationsSuccess: (notifications) => ({
    type: types.GET_NOTIFICATIONS_SUCCESS,
    payload: { notifications },
  }),
  failureGetNotifications: (error) => ({
    type: types.GET_NOTIFICATIONS_FAILURE,
    payload: error,
  }),
  changeShowNotificationsBar: (show) => ({
    type: types.SHOW_NOTIFICATIONS_BAR,
    payload: { show },
  }),
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case types.GET_NOTIFICATIONS:
      return {
        ...state,
        notificationsFetching: true,
        notificationsError: false,
      };
    case types.GET_NOTIFICATIONS_SUCCESS:
      const { notifications } = payload;
      return {
        ...state,
        notifications: notifications,
        notificationsFetching: false,
        notificationsError: false,
      };
    case types.GET_NOTIFICATIONS_FAILURE:
      const { error } = payload;
      return {
        ...state,
        notificationsFetching: false,
        notificationsError: true,
      };
    case types.SHOW_NOTIFICATIONS_BAR:
      // const lastShowNotificationsBar = state.showNotificationsBar;
      const { show } = payload;
      return {
        ...state,
        showNotificationsBar: show,
      };
    default:
      return state;
  }
}

export default reducer;
